import { Grid } from "@material-ui/core";
import Controls from "../../../../components/controls/Controls";
import FormBase from "../../../../forms/FormBase";
import InterestReasonsDataForm from "../../../../forms/corpoClinico/InterestReasonsDataForm";

interface IInterestReasonsDataComponentProps {
  InterestReasonsDataForm: InterestReasonsDataForm;
  onInputChange: (name: string, form: FormBase, value: any) => void;
}

export default function InterestReasonsDataComponent(
  props: IInterestReasonsDataComponentProps
) {
  return (
    <div>
      <Grid container spacing={5}>
        <Grid item xs={6} sm={12}>
          <Controls.Input
            name="Reason"
            label="Qual a razão de seu interesse em ser membro do Corpo Clínico do Hospital Sírio-Libanês?"
            placeholder="Digite a razão de interesse"
            multiline
            question
            rows={8}
            maxLength={500}
            value={props.InterestReasonsDataForm.Reason.Value}
            onChange={(e) => {
              props.onInputChange(
                "Reason",
                props.InterestReasonsDataForm,
                e.target.value
              );
            }}
            onBlur={(e) => {
              props.onInputChange(
                "Reason",
                props.InterestReasonsDataForm,
                e.target.value
              );
            }}
            error={props.InterestReasonsDataForm.Reason.Error}
          />
        </Grid>

        <Grid item xs={12}>
          <Controls.Input
            name="HowToContribute"
            label="Como poderia contribuir com o Hospital Sírio-Libanês na área assistencial ou acadêmica?"
            placeholder="Digite como poderia contribuir"
            multiline
            question
            rows={8}
            maxLength={500}
            value={props.InterestReasonsDataForm.HowToContribute.Value}
            onChange={(e) => {
              props.onInputChange(
                "HowToContribute",
                props.InterestReasonsDataForm,
                e.target.value
              );
            }}
            onBlur={(e) => {
              props.onInputChange(
                "HowToContribute",
                props.InterestReasonsDataForm,
                e.target.value
              );
            }}
            error={props.InterestReasonsDataForm.HowToContribute.Error}
          />
        </Grid>
      </Grid>
    </div>
  );
}
